import React, { useContext, useEffect } from 'react'
import { Alert } from 'components'
import { Form, RenderFields } from 'components/Form'
import { useAlert } from 'components/Alerts/hooks'
import { TestTakerForm, WrapStepFields, WrapTestTakerForm } from './Style'
import { useSelector } from 'react-redux'
import { submit } from 'redux-form'
import { useDispatch } from 'react-redux'
import { testTakerHooks, validate } from 'pages/School/CreateTestTaker'
import { AbilityContext } from 'components/Permissions/Can'
import { CreateTestTakerContext } from './CreateTestTakerContext'

//this file we use to create a test_taker
const NewChildPopup = () => {
    const { tzApproved, initialValues, formname } = useContext(CreateTestTakerContext)
    const formValues = useSelector(state => state.form[formname]?.values)
    const ability = useContext(AbilityContext)

    const dispatch = useDispatch()

    const { initialFields, fields, learningGroupFields } = testTakerHooks.useFormFields()
    const submitBtns = testTakerHooks.useSubmitBtns()
    const setAlert = testTakerHooks.useAlert()
    const resetForm = testTakerHooks.useRestForm()

    // בדיקה האם ההרשאה היא של תלמיד או של משתמש אחר, תצוגה ל טקסט מעט שונה
    const student = ability.can("read", "student-label") ? "תלמיד" : "ילד"

    useEffect(() => {
        // שליחה ליצרת התלמיד - מקפיץ את רשימת שגיאות הוולידצייה בטופס
        setTimeout(() => {
            dispatch(submit(formname))
        }, 1000);

        // יציאה מהפופאפ מנקה את הטופס
        return (() => {
            resetForm()
        })
    }, [])

    // אם סוג שיוך התלמיד הוא שיוך שלא בית ספרי, אנחנו מוסיפים עוד מספר שדות שחובה למלא
    let fullFormFields = fields
    if (formValues?.learningUnitType == 'learning_group')
        fullFormFields = fullFormFields.concat(learningGroupFields)

    const title = `מה הפרטים של ה${student} שאותו נאבחן?`;
    const footerActions = tzApproved ? submitBtns : undefined;

    return (
        <Alert
            title={title}
            footerActions={footerActions}
            handleAlert={() => setAlert(false)}
        >
            <WrapTestTakerForm>
                <Form
                    form={formname}
                    validations={validate}
                    fields={[]}
                    csswrap={tzApproved ? TestTakerForm : null}
                    submit={() => { }}
                    initialValues={initialValues}
                >
                    {tzApproved || <div className='initial-fields'>
                        <RenderFields fields={initialFields} />
                    </div>}
                    {tzApproved &&
                        <RenderFields fields={fullFormFields} />}
                </Form>
            </WrapTestTakerForm>
        </Alert>
    )
}

export default NewChildPopup